var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUCause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 465,
    height: 467,
    viewBox: "0 0 465 467",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M464.965 425.63L423.775 467H41.1896L0 425.63V0H219.865V233.5C219.865 237.489 221.306 240.842 224.188 243.489C227.07 246.172 230.514 247.055 234.486 246.172C238.035 245.713 240.671 244.266 242.464 241.83C244.221 239.395 245.135 236.395 245.135 232.829V0H465V425.63H464.965Z",
    fill: "#FEFEE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUCause);
export default __webpack_public_path__ + "static/media/U-Cause.c77876b13a1bf524fbe65ae03485a2d5.svg";
export { ForwardRef as ReactComponent };